export default __webpack_public_path__ + "static/media/DSC_0552.b62a86a2.jpg";